// import React, { Component } from 'react';

// class TableHelper extends Component {
//     constructor(props) {
//     super(props);
//     this.state = {
//         columns: []
//     };

// }
// componentDidMount(){

// }
//     getTableService(TableId){
//         fetch(process.env.REACT_APP_API_URL + "/api/getTableById", {
//             method: "post",
//             headers: {
//                 "Content-Type": "application/json",
//                 Accept: "application/json",
//             },
//             body: JSON.stringify({
//                 id: TableId,
//             }),
//         })
//             .then((Response) => Response.json()).then((result)=>
//             { 
                
//              return result[0].TableColumn
                
//             })
    
//     }
//     render() {
//         return (
//             <div>
//                 s
//             </div>
//         );
//     }
// }

// export default TableHelper;

export const getTableService = (TableId) =>{
    return (fetch(process.env.REACT_APP_API_URL + "/api/getTableById", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify({
            id: TableId,
        }),
    })
        .then((Response) => Response.json()).then((result)=>
        { 
            
         return result
            
        }))

}